import {
  Component, OnInit, QueryList,
  ElementRef,
  ViewChildren,
  ChangeDetectorRef
} from '@angular/core';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { CommonService } from "../../_services/common.service";
import { InkColorPickerComponent } from '../ink-color-picker/ink-color-picker.component';
import { MatDialog } from "@angular/material";
import { PfArtfileComponent } from '../pf-artfile/pf-artfile.component';
import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from '@angular/router';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { SettingService } from '../../_services/setting.service';
@Component({
  selector: 'app-print-specs',
  templateUrl: './print-specs.component.html',
  styleUrls: ['./print-specs.component.css']
})
export class PrintSpecsComponent implements OnInit {
  public locationOptionData: any = {};
  public totalProjectQuantity: any = [];
  public grandTotalPrice = 0;
  public activeLocationArr = [];
  public activeProjectIndex = "";
  public projects: any = {};
  public artworkPrintOpt: any = {};
  public inkColors = [];
  public maxInkLength = 0;
  public artworkHexColors: any = {};
  public otherPrintSettings = {};
  public active_artwork_loc = null;
  public activeSection = null;
  public activeStep = null;
  public artworkImg = null;
  public imgName = null;
  public active_uui = null;
  public printAddonInputSettingObj: any = {};
  public selectedAdonsObj: any = {};
  public selectedAdons: any = {};
  public selectedInkColorObj: any = {};
  public selectedInkColor: any = {};
  public tempProjectData: any = {};
  private cx: CanvasRenderingContext2D;
  public imageUrl: string;
  public inkChangeObj = {};
  public inkChangeData = {};
  public upd_location_images = [];
  public location_images = [];
  public tmp_location_images = [];
  public productMatrix: any = [];
  public activeInkChangeIndex = 0;
  public inkTypeLists: Array<any> = [];
  public orderType: string;
  public prevPrice = 0;
  public getmax = 0;
  public stitches_per_inch: number = 0;
  public isPantoneExist = {
    'front': true,
    'back': true,
    'left': true,
    'right': true
  }
  public loading: boolean = false;
  public loadingArt: boolean = true;
  public timeoutId: any;
  public projectIndexForCheckboxTabs: Array<any> = [];
  public artworkPrintOptLength = 0;
  public isPublicQuoteCreation = false;
  public tooltipOptions: any = [];
  locationList: Array<any> = [];
  priceMatrixList: Array<any> = [];
  @ViewChildren("canvas") canvasList: QueryList<ElementRef>;
  optionIndexes: {}
  public isTurnOffImpressionCost = false;

  constructor(private CommonProjectDataService: CommonProjectDataService,
    private CommonService: CommonService,
    private dialog: MatDialog,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
    private settingService: SettingService,
    private cdRef: ChangeDetectorRef) {
    this.locationPrintDetails();
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    this.isAccessInvoiceType();
  }

  ngOnInit() {
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex();
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    this.orderType = this.CommonProjectDataService.getOrderType();
    this.isTurnOffImpressionCost = this.CommonProjectDataService.getTurnOffImpressionCost();
    this.totalProjectQuantity = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalProjectQuantity()));
    this.grandTotalPrice = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalPrice()));
    this.artworkHexColors = this.projects.projects_data[this.activeProjectIndex]["artwork"] ? this.projects.projects_data[this.activeProjectIndex]["artwork"] : {};
    this.activeLocationArr = this.projects.projects_data[this.activeProjectIndex]["active_location_arr"] ? this.projects.projects_data[this.activeProjectIndex]["active_location_arr"] : [];
    this.active_artwork_loc = this.projects.projects_data[this.activeProjectIndex]["active_location_arr"] ? this.projects.projects_data[this.activeProjectIndex]["active_location_arr"][0] : null;
    this.printAddonInputSettingObj = this.projects.projects_data[this.activeProjectIndex]["printAddonInputSettingObj"] ? this.projects.projects_data[this.activeProjectIndex]["printAddonInputSettingObj"] : {};
    this.selectedAdonsObj = this.projects.projects_data[this.activeProjectIndex]["printAddonSwatchSettingObj"] ? this.projects.projects_data[this.activeProjectIndex]["printAddonSwatchSettingObj"] : {};
    this.selectedAdons = (this.projects.projects_data[this.activeProjectIndex]["printAddonSetting"]) ? this.projects.projects_data[this.activeProjectIndex]["printAddonSetting"] : {};
    this.selectedInkColorObj = this.projects.projects_data[this.activeProjectIndex]["inkColorObj"] ? this.projects.projects_data[this.activeProjectIndex]["inkColorObj"] : {};
    this.selectedInkColor = this.projects.projects_data[this.activeProjectIndex].inkColors ? this.projects.projects_data[this.activeProjectIndex].inkColors : {};
    this.inkChangeData = this.projects.projects_data[this.activeProjectIndex][
      "inkChangeData"
    ]
      ? this.projects.projects_data[this.activeProjectIndex]["inkChangeData"]
      : {};
    let tmp_artwork_arr = [];
    if (this.projects.projects_data[this.activeProjectIndex]["products"].length >= 0) {
      this.projects.projects_data[this.activeProjectIndex]["products"].forEach(
        (project, key) => {
          project.matrix.forEach((mvalue, key) => {
            tmp_artwork_arr.push({
              style_image: project.productDetail.style_image,
              brand: project.productDetail.brand,
              product_name: project.productDetail.name,
              color: mvalue.color,
              product_id: project.productDetail.product_id,
              is_og: project.productDetail.title == "own-garment" ? 1 : 0
            });
          });
        }
      );
    }
    this.location_images = JSON.parse(JSON.stringify(tmp_artwork_arr));
    this.tmp_location_images = JSON.parse(JSON.stringify(tmp_artwork_arr));
    this.setDefaultInkType();
    this.prevPrice = JSON.parse(localStorage.getItem('prevPrice'));
    this.getProductMatrix('all');
    this.productMatrix = this.CommonProjectDataService.getProductMatrix();
    this.showConfirmMessage();
    this.CommonProjectDataService.storeCurrentIndexForStep(3);
    this.tooltipOptions = sessionStorage.getItem('tooltipOptions') ? JSON.parse(sessionStorage.getItem('tooltipOptions')) : [];
  }

  ngAfterViewInit() {
    if (this.activeLocationArr.length > 0) {
      let images = [];
      this.activeLocationArr.forEach((cval, ckey) => {
        if (this.artworkHexColors[cval.emblocation_id] && this.artworkHexColors[cval.emblocation_id].img_ext_path) {
          let url = this.artworkHexColors[cval.emblocation_id].img_ext_path;
          let image = new Image();
          image.src = url;
          images.push(image);
          image.addEventListener('load', () => {
            if (images.every(img => img.complete)) {
              // Call the displayAllCanvasImages() method once all the images have finished loading
              this.displayAllCanvasImages();
              this.loadingArt = false;
              this.cdRef.detectChanges();
            }
          });
        }
        else {
          this.loadingArt = false;
          this.cdRef.detectChanges();
        }
      });
    }
    else {
      this.loadingArt = false;
      this.cdRef.detectChanges();
    }
  }

  getLocationList = function () {
    let options = {
      id: localStorage.getItem("userID")
    }
    this.CommonService.apiService(
      "POST",
      "emblocation/list",
      options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.locationList = response.data.records;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  getOtherPrintSetting() {
    if (this.projects.projects_data[this.activeProjectIndex]['printPositionSetting'] && this.projects.projects_data[this.activeProjectIndex]['active_location_arr'] && this.projects.projects_data[this.activeProjectIndex].active_location_arr.length > 0) {
      this.activeLocationArr.forEach((cval, ckey) => {

        let tmpData = this.projects.projects_data[this.activeProjectIndex].printPositionSetting[cval.emblocation_id];
        if (tmpData && tmpData != undefined) {
          let selectedOptionIndex = this.artworkPrintOpt[cval.emblocation_id].locationSetting.findIndex(x => x.id == tmpData.selectedOptionId);
          let printType = this.artworkPrintOpt[cval.emblocation_id].locationSetting[selectedOptionIndex].matrixType;
          this.stitches_per_inch = (tmpData.custom_stitches_per_inch) ? tmpData.custom_stitches_per_inch : 0;
          let placementIndex = this.artworkPrintOpt[cval.emblocation_id].locationSetting[selectedOptionIndex].printPositions.findIndex(x => x.print_position_id == tmpData.printPosition.print_position_id);
          this.inkColors = tmpData.priceMatrix.inks;
          this.otherPrintSettings[cval.emblocation_id] = {
            printPosition: tmpData.printPosition,
            nameTotalCount: tmpData.nameTotalCount,
            numberTotalCount: tmpData.numberTotalCount,
            printDistance: tmpData.printDistance,
            printWidth: tmpData.printWidth,
            printHeight: tmpData.printHeight,
            printDesciption: tmpData.printDesciption,
            changeName: tmpData.changeName,
            changeNumber: tmpData.changeNumber,
            priceMatrix: tmpData.priceMatrix,
            selectedOptionId: tmpData.selectedOptionId,
            placementIndex: placementIndex,
            selectedOptionIndex: selectedOptionIndex,
            includePreTreat: tmpData.includePreTreat,
            printType: printType,
            custom_stitches_per_inch: this.stitches_per_inch
          };
        }
      });
    }
  }

  isActiveLocation(locs) {
    return this.activeLocationArr.findIndex(x => x.emblocation_id == locs) >= 0 ? true : false;
  }

  setActiveLocation(locs, section, steptype) {
    this.active_artwork_loc = locs;
    this.activeSection = section;
    this.activeStep = steptype;
    if (section == "artwork") {
      this.artworkImg = null;
    }
    if (section == "inkchange") {
      if (this.selectedInkColorObj[locs]) {
        this.tmp_location_images = JSON.parse(JSON.stringify(this.location_images));
        this.upd_location_images = [];
        this.activeInkChangeIndex = 0;
        let inkDataTmp = this.inkChangeData[this.active_artwork_loc]
          ? this.inkChangeData[this.active_artwork_loc]["updData"]
          : [];
        let inkDataLeftTmp = this.inkChangeData[this.active_artwork_loc]
          ? this.inkChangeData[this.active_artwork_loc]["leftData"]
          : [];
        let inkColorChangeTmp = this.inkChangeData[
          this.active_artwork_loc
        ]
          ? this.inkChangeData[this.active_artwork_loc]["colorChange"]
          : {};
        let inkColorTotalChangeTmp = this.inkChangeData[
          this.active_artwork_loc
        ]
          ? this.inkChangeData[this.active_artwork_loc]["totalColor"]
          : 0;
        this.inkChangeData[this.active_artwork_loc] = {
          updData: inkDataTmp,
          leftData: inkDataLeftTmp,
          colorChange: inkColorChangeTmp,
          totalColor: inkColorTotalChangeTmp
        };
        let tmpLocationImages =
          this.inkChangeData[this.active_artwork_loc]["updData"].length >
            0
            ? this.inkChangeData[this.active_artwork_loc]["leftData"]
            : this.tmp_location_images;

        let tmpTotalChangedColor = [];
        if (this.inkChangeData[this.active_artwork_loc]["updData"].length > 0) {
          this.inkChangeData[this.active_artwork_loc]["updData"].map(subArr => {
            if (subArr.length > 0) {
              tmpTotalChangedColor = tmpTotalChangedColor.concat(subArr);
            }
          }
          );
        }
        if (tmpTotalChangedColor.length > 0) {
          tmpLocationImages = this.location_images.filter(this.comparer(tmpTotalChangedColor));
          this.inkChangeData[this.active_artwork_loc]["leftData"] = tmpLocationImages;
        }
        this.tmp_location_images = tmpLocationImages;
      }
    }
    if (section == "inkcolor") {
      if (!(this.selectedAdons[this.active_artwork_loc] && this.selectedAdons[this.active_artwork_loc][this.artworkPrintOpt[this.active_artwork_loc].addOns[0].add_on_id])) {
        this.selectedAdons[this.active_artwork_loc] = {
          [this.artworkPrintOpt[this.active_artwork_loc].addOns[0]['add_on_id']]: new Array(this.artworkPrintOpt[this.active_artwork_loc].addOns[0].number_of_input_box).fill(null)
        };
        this.isPantoneExist[this.active_artwork_loc] = false;
      }
    }

    // call popup
    if (section == "artwork" && this.activeStep == "steptwo") {
      let projectData = this.projects.projects_data[this.activeProjectIndex];
      let url = (projectData.artwork && projectData.artwork[this.active_artwork_loc] && projectData.artwork[this.active_artwork_loc].img_ext_path) ? projectData.artwork[this.active_artwork_loc].img_ext_path : '';
      let art_img = (projectData.artwork && projectData.artwork[this.active_artwork_loc] && projectData.artwork[this.active_artwork_loc].artwork_img) ? projectData.artwork[this.active_artwork_loc].artwork_img : '';
    }
    else {
      this.showInkColorPicker(section);
    }
  }

  locationPrintDetails = function () {
    let options = {
      'id': localStorage.getItem("userID")
    }
    this.CommonService.apiService(
      "POST",
      "v3/print/options",
      options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.inkColors = [];
            this.artworkPrintOpt = response.data;
            var keys = Object.keys(this.artworkPrintOpt);
            this.artworkPrintOptLength = keys.length;
            this.getLocationList();
            this.getOtherPrintSetting();
            this.maxInkLength = 9;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  setPrintLocation(locs) {
    this.active_artwork_loc = locs;
    if (Object.keys(this.artworkPrintOpt).length > 0) {
      let defaultPrintPosition = JSON.parse(JSON.stringify(this.artworkPrintOpt[locs.emblocation_id].locationSetting[0]['printPositions'][0]));
      let buttontitle = JSON.parse(JSON.stringify(this.artworkPrintOpt[locs.emblocation_id].locationSetting[0]['buttonTitle']));
      let defaultMatrix = defaultPrintPosition.matrixData.find(x => x.is_default == 1);
      if (this.activeLocationArr.length > 1) {
        let secondaryMatrix = defaultPrintPosition.matrixData.find(x => x.is_secondary == 1);
        defaultMatrix = secondaryMatrix ? secondaryMatrix : defaultMatrix;
      }
      defaultMatrix = defaultMatrix ? defaultMatrix : defaultPrintPosition.matrixData[0];
      this.inkColors = defaultMatrix.inks;
      let selectedPrintOtionId = JSON.parse(JSON.stringify(this.artworkPrintOpt[locs.emblocation_id].locationSetting[0].id));
      let matrixType = JSON.parse(JSON.stringify(this.artworkPrintOpt[locs.emblocation_id].locationSetting[0].matrixType));
      let custom_stitches_per_inch = 0;
      let findex = this.activeLocationArr.findIndex(x => x.emblocation_id == locs.emblocation_id);
      locs.emblocation_button_title = buttontitle;
      if (findex < 0) {
        this.activeLocationArr.push(locs);
        this.otherPrintSettings[this.active_artwork_loc.emblocation_id] = {
          printPosition: defaultPrintPosition,
          nameTotalCount: '',
          numberTotalCount: '',
          printDistance: '',
          printWidth: matrixType == 'per_item' ? defaultMatrix.width : '',
          printHeight: matrixType == 'per_item' ? defaultMatrix.height : '',
          custom_stitches_per_inch: custom_stitches_per_inch,
          printDesciption: '',
          priceMatrix: defaultMatrix,
          selectedOptionId: selectedPrintOtionId,
          placementIndex: 0,
          selectedOptionIndex: 0,
          includePreTreat: false,
          activeClass: 'active',
          printType: matrixType
        };
      } else {
        this.activeLocationArr.splice(findex, 1);
        delete this.selectedInkColorObj[this.active_artwork_loc.emblocation_id];
        delete this.selectedInkColor[this.active_artwork_loc.emblocation_id];
        delete this.inkChangeObj[this.active_artwork_loc.emblocation_id];
        delete this.inkChangeData[this.active_artwork_loc.emblocation_id];
        delete this.artworkHexColors[this.active_artwork_loc.emblocation_id];
        delete this.selectedAdons[this.active_artwork_loc.emblocation_id];
        this.otherPrintSettings[this.active_artwork_loc.emblocation_id] = {};
        this.active_artwork_loc = null;
        this.processPrintData();
        this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
        this.getPrice(this.tempProjectData);

      }
    }
  };

  addPosition(printPostion, loc, selectedMatrixId) {
    let selectedOptionIndex = this.otherPrintSettings[loc].selectedOptionIndex;
    if (selectedMatrixId) {
      let addPosition = this.artworkPrintOpt[loc].locationSetting[selectedOptionIndex]['printPositions'].find(x => x.name === printPostion);

      if (addPosition) {
        this.otherPrintSettings[loc].priceMatrix = JSON.parse(JSON.stringify(addPosition.matrixData.find(x => x.matrix_id == selectedMatrixId)));
        this.otherPrintSettings[loc]['printPosition'].print_position_id = JSON.parse(JSON.stringify(addPosition.print_position_id));
      }
      else {
        this.otherPrintSettings[loc]['printPosition'] = { print_position_id: '', name: '' };
      }
    }

    this.processPrintData();
    let matrixType = this.artworkPrintOpt[loc].locationSetting[this.otherPrintSettings[loc].selectedOptionIndex].matrixType;
    if (matrixType == 'per_color' || matrixType == 'per_item') {
      if (this.selectedInkColorObj[loc].length > 0 || this.selectedAdons[loc].length > 0) {

        this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
        this.getPrice(this.tempProjectData);
      }
    }
    else {
      this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
      this.getPrice(this.tempProjectData);
    }
  }

  addCustomStitches(customStitches, loc) {
    this.processPrintData();
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    this.getPrice(this.tempProjectData);
  }

  addMesurment(data, loc, actualMinValue, type) {
    if (data >= actualMinValue) {
      this.processPrintData();
      if (loc != '') {
        let matrixType = this.artworkPrintOpt[loc].locationSetting[this.otherPrintSettings[loc].selectedOptionIndex].matrixType;
        if (matrixType != 'per_color' && matrixType != 'per_item') {
          this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
          this.getPrice(this.tempProjectData);
        }
      }
    }
    else {
      if (type == 1) {
        this.otherPrintSettings[loc].printWidth = 0;
      } else if (type == 2) {
        this.otherPrintSettings[loc].printDistance = 0;
      } else if (type == 3) {
        this.otherPrintSettings[loc].printHeight = 0;
      }
      this.processPrintData();
      let matrixType = this.artworkPrintOpt[loc].locationSetting[this.otherPrintSettings[loc].selectedOptionIndex].matrixType;
      if (matrixType != 'per_color' && matrixType != 'per_item') {
        this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
        this.getPrice(this.tempProjectData);
      }
    }
  }

  processAddonData() {
    let tmpInpSetting = {};
    for (let [key, value] of Object.entries(this.selectedAdons)) {
      let addoneId = this.artworkPrintOpt[key].addOns[0]['add_on_id'];
      let inputLength = this.selectedAdons[key][addoneId].filter(x => x != null && x != '').length;
      if (inputLength > 0) {
        this.isPantoneExist[this.active_artwork_loc] = true;
        for (let [skey, sval] of Object.entries(value)) {
          if (!Array.isArray(sval)) {
            if (tmpInpSetting[key] && !this.isObjectEmpty(tmpInpSetting[key])
            ) {
              Object.assign(tmpInpSetting[key], { [skey]: sval });
            } else {
              if (!this.isObjectEmpty(sval)) {
                tmpInpSetting[key] = { [skey]: sval };
              }
            }
          }
          else {
            let filtered = sval.filter(function (el) { return (el != null && el != ''); });
            if (tmpInpSetting[key] && !this.isObjectEmpty(tmpInpSetting[key])) {
              Object.assign(tmpInpSetting[key], { [skey]: filtered });
            } else {
              if (!this.isObjectEmpty(sval)) {
                tmpInpSetting[key] = { [skey]: filtered };
              }
            }
          }
        }
      }
      else { delete tmpInpSetting[key] }
    }

    let tmpAddonObj = {};
    this.activeLocationArr.forEach((pdata, key) => {
      if (this.artworkPrintOpt && this.artworkPrintOpt[pdata.emblocation_id]) {
        tmpAddonObj[pdata.emblocation_id] = this.artworkPrintOpt[pdata.emblocation_id].addOns;
      }
    });

    this.projects.projects_data[this.activeProjectIndex]["printAddonSwatchSettingObj"] =
      Object.assign({}, this.selectedAdonsObj);
    this.projects.projects_data[this.activeProjectIndex]["printAddonSettingObj"] =
      tmpAddonObj;
    this.projects.projects_data[this.activeProjectIndex][
      "printAddonInputSettingObj"
    ] = tmpInpSetting;
    this.selectedAdons = tmpInpSetting;
    this.printAddonInputSettingObj = tmpInpSetting;
    this.projects.projects_data[this.activeProjectIndex]["printAddonSetting"] =
      Object.assign({}, tmpInpSetting);

    if (!this.projects.projects_data[this.activeProjectIndex]["printPositionSetting"]) {
      this.projects.projects_data[this.activeProjectIndex]["printPositionSetting"] = {};
    }
  }

  isObjectEmpty(temObj) {
    return Object.keys(temObj).length == 0 ? true : false;
  }

  getPrice = function (datarecord) {
    let projects = datarecord;
    let user_id = this.projects.user_id;
    let finalArr = []

    projects.forEach((pvalue, pkey) => {
      let projectTitle = (pvalue.projectTitle) ? pvalue.projectTitle : "";
      if (sessionStorage.getItem(`projectTitle_${pkey}`)) {
        projectTitle = sessionStorage.getItem(`projectTitle_${pkey}`);
      }
      let isCheckedProjectTab = (pvalue.isCheckedProjectTab) ? pvalue.isCheckedProjectTab : "";
      let totalPriceCalculation = (pvalue.totalPriceCalculation) ? pvalue.totalPriceCalculation : false;
      if (pvalue.products && pvalue.products.length > 0) {
        pvalue.products.forEach((product, key) => {
          if (finalArr[pkey] && finalArr[pkey].products) {
            Object.assign(finalArr[pkey].products, { [product.product_id]: {} });
            Object.assign(finalArr[pkey].products_matrix, { [product.product_id]: {} });
          }
          else {
            finalArr[pkey] = {
              'products': { [product.product_id]: {} },
              'products_matrix': { [product.product_id]: {} },
              'printPositionSetting': pvalue.printPositionSetting,
              'finishingDetails': (pvalue.finishing_type_id) ? pvalue.finishing_type_id : [],
              'inkDetail': (pvalue.ink_Details && pvalue.ink_Details.ink_type_id) ? pvalue.ink_Details.ink_type_id : null,
              'section_items': pvalue.section_items,
              'isCheckedProjectTab': isCheckedProjectTab,
              'projectTitle': projectTitle,
              'productsMatrixData': pvalue.products,
              'totalPriceCalculation': totalPriceCalculation
            };
          }

          finalArr[pkey].ownGarmentsWeight = pvalue.ownGarmentsWeight;
          // set inkColors under printPositionSetting
          this.activeLocationArr.forEach((lval, lkey) => {
            if (pvalue.printPositionSetting[lval.emblocation_id] && pvalue.printPositionSetting[lval.emblocation_id] != undefined) {
              let selctedname = this.artworkPrintOpt[lval.emblocation_id].locationSetting.filter(x => x.id == (pvalue.printPositionSetting[lval.emblocation_id]) ? (pvalue.printPositionSetting[lval.emblocation_id].selectedOptionId) : '');
              if (selctedname.length > 0) {
                this.stitches_per_inch = this.otherPrintSettings[lval.emblocation_id].custom_stitches_per_inch;
                pvalue.printPositionSetting[lval.emblocation_id]["custom_stitches_per_inch"] = this.stitches_per_inch;
              }
              if (pvalue.inkColors && pvalue.inkColors[lval.emblocation_id]) {
                let tmpInkColor = (pvalue.inkColors[lval.emblocation_id]) ? pvalue.inkColors[lval.emblocation_id] : [];
                if (pvalue.printPositionSetting[lval.emblocation_id]) {
                  pvalue.printPositionSetting[lval.emblocation_id]['inkColors'] = tmpInkColor;
                }
                else {
                  pvalue.printPositionSetting[lval.emblocation_id] = { ['inkColors']: tmpInkColor };
                }
                if (pvalue.printPositionSetting[lval.emblocation_id]) {
                }
              }
              if (pvalue.printAddonSetting) {
                if (pvalue.printPositionSetting[lval.emblocation_id]) {
                  pvalue.printPositionSetting[lval.emblocation_id]['printAddonSetting'] = (pvalue.printAddonSetting[lval.emblocation_id]) ? pvalue.printAddonSetting[lval.emblocation_id] : {};
                }
              }

              // set inkChangeData under printPositionSetting
              if (pvalue.inkChangeData) {
                if (pvalue.printPositionSetting[lval.emblocation_id]) {

                  if (pvalue.inkChangeData[lval.emblocation_id]) {

                    pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = this.processInkChangeData(pvalue.inkChangeData[lval.emblocation_id]);

                  }
                  else {
                    pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = [];
                  }

                }
              }
              if (pvalue.artwork) {
                let artTmp = Object.keys(pvalue.artwork).length;
                if (pvalue.artwork && artTmp > 0) {
                }
              }
              finalArr[pkey].printPositionSetting = pvalue.printPositionSetting;
            }
          });
          product.matrix.forEach(function (mval, mkey) {
            if (finalArr[pkey].products[product.product_id]) {
              Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
              Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
            }
            else {
              finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
              finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
            }
            mval.quantity.forEach(function (qval, qkey) {
              if (qval && qval > 0) {
                if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                  Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                }
                else {
                  finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                }
              }
            });
          });
        });
      }

    });

    this.address_id = (this.projects.shipping_address && this.projects.shipping_address.address_id) ? this.projects.shipping_address.address_id : this.projects.address_id ? this.projects.address_id : '';

    let otherData = {
      user_id: this.projects.user_id ? this.projects.user_id : '',
      address_id: this.address_id,
      turn_around_time: this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
      shipping_method: this.projects.shipping_method_key == "null" ? "" : this.projects.shipping_method_key
    }
    let quoteOpt = {
      id: localStorage.getItem("userID"),
      projects_data: finalArr,
      user_id: otherData.user_id,
      address_id: otherData.address_id,
      turn_around_time: otherData.turn_around_time,
      shipping_method: otherData.shipping_method,
      one_time_discount_type: this.projects.one_time_discount_type ? this.projects.one_time_discount_type : '',
      one_time_discount: this.projects.one_time_discount ? this.projects.one_time_discount : 0

    };
    this.CommonService.apiService(
      "POST",
      "v3/order/get_prices",
      quoteOpt
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.grandTotalPrice = response.data.grand_total_price;
          this.CommonProjectDataService.storeTotalPrice(response.data.grand_total_price);
          if(this.orderType == 'Quote'){
            this.projects.delivery_date = response.data.delivery_date;
          }
          this.projects.delivery_days = response.data.delivery_days;
          this.projects.discount = response.data.discount;
          this.projects.discount_percentage = response.data.discount_percentage;
          this.projects.grand_total_price = response.data.grand_total_price;
          this.projects.shipping_price = response.data.shipping_price;
          this.projects.tax = response.data.tax;
          this.projects.tax_percentage = response.data.tax_percentage;
          this.projects.total_price = response.data.total_price;
          this.projects.total_printing_price = response.data.total_printing_price;
          this.projects.total_products_price = response.data.total_products_price;
          this.projects.total_quantity = response.data.total_quantity;
          this.projects.total_weight = response.data.total_weight;
          this.projects.turn_around_time_price = response.data.turn_around_time_price;
          this.projects.total_projects = response.data.total_projects;
          this.projects.total_custom_items_price = response.data.total_custom_items_price;
          this.projects.turn_around_time = '0';
          this.projects.one_time_discount = response.data.one_time_discount;
          this.projects.one_time_discount_type = response.data.one_time_discount_type;
          this.projects.one_time_discounted_amt = response.data.one_time_discounted_amt;
          this.projects.per_product_price_distribution = response.data.per_product_price_distribution;

          // set  printing price  per project
          this.projects.projects_data[this.activeProjectIndex].total_printing_price = response.data.projects[this.activeProjectIndex].total_printing_price;

          this.projects.projects_data[this.activeProjectIndex].priceMarkupProduct = response.data.projects[this.activeProjectIndex].priceMarkupProduct;
          response.data.projects.forEach((projectValues, projectIndexing) => {
            this.projects.projects_data[projectIndexing].perProjectTotalCost = projectValues.perProjectTotalCost;
            this.projects.projects_data[projectIndexing].products = projectValues.productsMatrixData;
            this.projects.projects_data[projectIndexing].priceDistributionData = projectValues.perProductPriceDistributionData;
            this.projects.projects_data[projectIndexing].projectTitle = projectValues.projectTitle;
          });

          if (otherData.shipping_method == "" || otherData.shipping_method == "local_pickup") {
            this.projects.shipping_method = response.data.shipping_methods.local_pickup;
          }

          this.loading = false;
          this.showConfirmMessage();
        }
      },
      err => {
        this.loading = false;
        console.log("error msg", err.error.message);
      }
    );
  }

  callArtfileStepTwo(section, activeStep, url, artwork_img) {
    const dialogRef = this.dialog.open(PfArtfileComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        inkColors: this.inkColors,
        active_artwork_loc: this.active_artwork_loc,
        selectedInkColor: this.selectedInkColor,
        selectedInkColorObj: this.selectedInkColorObj,
        projects: this.projects,
        activeProjectIndex: this.activeProjectIndex,
        active_location_arr: this.activeLocationArr,
        artworkPrintOpt: this.artworkPrintOpt,
        selectedAdons: this.selectedAdons,
        maxInkLength: this.maxInkLength,
        section: section,
        activeStep: activeStep,
        artworkHexColors: this.artworkHexColors,
        otherPrintSettings: this.otherPrintSettings,
        url: url,
        artwork_img: artwork_img,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        this.displayCanvasImage(result, '', this.active_artwork_loc, 0);
      }
      this.processPrintData();
      this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
      this.getPrice(this.tempProjectData);

    });
  }
  displayAllCanvasImages() {
    if (this.activeLocationArr.length > 0) {
      this.activeLocationArr.forEach((cval, ckey) => {
        if (this.artworkHexColors[cval.emblocation_id] && this.artworkHexColors[cval.emblocation_id].img_ext_path) {
          let url = this.artworkHexColors[cval.emblocation_id].img_ext_path;
          let artFileType = '';
          let location = cval.emblocation_id;
          let index = 0;
          this.imageUrl = url;

          let urlExt = url.split(".").pop().toLowerCase();
          if (['ai', 'eps', 'pdf', 'tiff', 'tif', 'zip', 'cdr', 'ps'].indexOf(urlExt) !== -1) {
            url = 'assets/img/' + urlExt + '.png';
          }
          let canvasEl: HTMLCanvasElement;
          canvasEl = this.canvasList.find(x => x.nativeElement.id == location).nativeElement;
          this.cx = canvasEl.getContext('2d');
          let image = new Image();
          image.src = url;
          canvasEl.width = 550;
          canvasEl.height = 550;

          let renderableHeight = image.height;
          let renderableWidth = image.width;
          let xStart = (canvasEl.width - image.width) * 0.5;
          let yStart = (canvasEl.height - image.height) * 0.5;

          if (image.width >= canvasEl.width) {
            renderableWidth = canvasEl.width - 50;
            renderableHeight = image.height * (renderableWidth / image.width);
            xStart = (canvasEl.width - renderableWidth) / 2;
            yStart = (canvasEl.height - renderableHeight) / 2;
          }
          else {
            if (image.height > canvasEl.height) {
              renderableHeight = canvasEl.height;
              renderableWidth = image.width * (renderableHeight / image.height);
              xStart = (canvasEl.width - renderableWidth) / 2;
              yStart = 0;
            }
          }
          this.cx.drawImage(image, xStart, yStart, renderableWidth, renderableHeight);
        }
      });
    }
  }

  displayCanvasImage(url, artFileType, location, index) {
    this.imageUrl = url;
    let urlExt = url.split(".").pop().toLowerCase();
    if (['ai', 'eps', 'pdf', 'tiff', 'tif', 'zip', 'cdr', 'ps'].indexOf(urlExt) !== -1) {
      url = 'assets/img/' + urlExt + '.png';
    }
    let canvasEl: HTMLCanvasElement;
    canvasEl = this.canvasList.find(x => x.nativeElement.id == location).nativeElement;
    this.cx = canvasEl.getContext('2d');
    let image = new Image();
    image.src = url;
    canvasEl.width = 550;
    canvasEl.height = 550;
    let imageAspectRatio = image.width / image.height;
    let canvasAspectRatio = canvasEl.width / canvasEl.height;
    let renderableHeight = image.height;
    let renderableWidth = image.width;
    let xStart = (canvasEl.width - image.width) * 0.5;
    let yStart = (canvasEl.height - image.height) * 0.5;

    // If image's aspect ratio is greater than canvas's we fit on width
    // and place the image centrally along height

    if (image.width >= canvasEl.width) {
      renderableWidth = canvasEl.width - 50;
      renderableHeight = image.height * (renderableWidth / image.width);
      xStart = (canvasEl.width - renderableWidth) / 2;
      yStart = (canvasEl.height - renderableHeight) / 2;
    }
    else {
      if (image.height > canvasEl.height) {
        renderableHeight = canvasEl.height;
        renderableWidth = image.width * (renderableHeight / image.height);
        xStart = (canvasEl.width - renderableWidth) / 2;
        yStart = 0;
      }
    }
    this.cx.drawImage(image, xStart, yStart, renderableWidth, renderableHeight);

  }

  showInkColorPicker(section) {
    let activeloc = '';
    const dialogRef = this.dialog.open(InkColorPickerComponent, {

      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        inkColors: this.inkColors,
        active_artwork_loc: this.active_artwork_loc,
        selectedInkColor: this.selectedInkColor,
        selectedInkColorObj: this.selectedInkColorObj,
        projects: this.projects,
        activeProjectIndex: this.activeProjectIndex,
        active_location_arr: this.activeLocationArr,
        artworkPrintOpt: this.artworkPrintOpt,
        selectedAdons: this.selectedAdons,
        maxInkLength: this.maxInkLength,
        section: section,
        activeStep: this.activeStep,
        artworkHexColors: this.artworkHexColors,
        otherPrintSettings: this.otherPrintSettings,
        tmp_location_images: this.tmp_location_images,
        upd_location_images: this.upd_location_images,
        inkChangeData: this.inkChangeData,
        inkChangeObj: this.inkChangeObj,
        active_image_loc: this.activeLocationArr.find(x => x.emblocation_id == this.active_artwork_loc).active_image_loc

      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.processPrintData();
      this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
      this.getPrice(this.tempProjectData);
      if (section == "artwork" && result.activeStep == "steptwo") {
        let image = new Image();
        image.onload = () => {
          setTimeout(() => {
            this.displayCanvasImage(image.src, '', this.active_artwork_loc, 0);
          }, 100);
        };
        image.src = result.url;
      }
      if (section == 'inkchange' || section == 'custom') {
        this.setProjectIndexForCheckboxTabs(this.activeProjectIndex);
      }
    });
  }

  processPrintData() {
    this.projects.projects_data[this.activeProjectIndex]["artwork"] =
      Object.assign({}, this.artworkHexColors);
    this.projects.projects_data[this.activeProjectIndex]["inkColorObj"] =
      Object.assign({}, this.selectedInkColorObj);
    this.projects.projects_data[this.activeProjectIndex]["inkColors"] =
      Object.assign({}, this.selectedInkColor);
    let active_location_arr = this.activeLocationArr;
    this.projects.projects_data[this.activeProjectIndex]["active_location_arr"] = this.activeLocationArr;

    this.activeLocationArr.forEach((sval, skey) => {
      if (this.artworkHexColors[sval.emblocation_id] && !this.artworkHexColors[sval.emblocation_id].img_ext_path) {
        delete this.artworkHexColors[sval.emblocation_id];
      }
    })


    //prcess change name number
    let otherPrintSettings = this.processChangeNumberName();
    this.projects.projects_data[this.activeProjectIndex][
      "printPositionSetting"
    ] = otherPrintSettings;

    //process addon settings
    this.processAddonData();
    this.projects.projects_data[this.activeProjectIndex]["inkChangeObj"] =
      Object.assign({}, this.inkChangeObj);
    this.projects.projects_data[this.activeProjectIndex]["inkChangeData"] =
      Object.assign({}, this.inkChangeData);
    this.CommonProjectDataService.store(this.projects);
  }

  comparer(otherArray) {
    return function (current) {
      return otherArray.filter(function (other) {

        return other.color.name == current.color.name
      }).length == 0;
    }
  }

  processInkChangeData(inkData) {
    let tmpArr = [];
    inkData.updData.forEach((val, key) => {
      tmpArr[key] = { 'inkColors': [] };
    });

    Object.values(inkData.colorChange).forEach((val, key) => {
      Object.entries(val).forEach(
        ([pkey, value]) => {
          if (tmpArr[key].inkColors) {
            tmpArr[key].inkColors.push(val[pkey].upd.ink_id);
          }
          else {
            tmpArr[key] = { inkColors: [val[pkey].upd.ink_id] };
          }
        }
      );
    });
    return tmpArr;
  }

  processChangeNumberName() {
    let tmpOtherPs = JSON.parse(JSON.stringify(this.otherPrintSettings));
    for (const [okey, opObj] of Object.entries(tmpOtherPs)) {
      delete tmpOtherPs[okey].selectedOptionIndex;
      delete tmpOtherPs[okey].placementIndex;
      Object.assign(tmpOtherPs[okey], {
        nameTotalCount: 0,
        numberTotalCount: 0
      });
      if (opObj['changeName'] && Object.keys(opObj['changeName']).length > 0) {
        for (const [ckey, cval] of Object.entries(opObj['changeName'])) {

          for (const [ikey, ival] of Object.entries(cval)) {
            let resCountName = this.countObjValue(ival, String);
            tmpOtherPs[okey]["nameTotalCount"] =
              tmpOtherPs[okey]["nameTotalCount"] + resCountName;
          }
        }
      }
      if (opObj['changeNumber'] && Object.keys(opObj['changeNumber']).length > 0) {
        for (const [ckey, cval] of Object.entries(opObj['changeNumber'])) {

          for (const [ikey, ival] of Object.entries(cval)) {
            let resCountNum = this.countObjValue(ival, Number);
            tmpOtherPs[okey]["numberTotalCount"] =
              tmpOtherPs[okey]["numberTotalCount"] + resCountNum;
          }
        }
      }
    }
    return tmpOtherPs;
  };

  countObjValue(data, cType) {
    const peopleArray = Object.keys(data)
      .map(k => data[k])
      .filter(cType).filter((el) => el != null)
    return peopleArray.length;
  };

  setDefaultInkType() {
    this.inkTypeLists = this.CommonProjectDataService.getInkTypeRequest();
    if (this.inkTypeLists && this.inkTypeLists.length > 0) {
      if (this.inkTypeLists.length == 1) {
        let selectedInkTypeId = this.inkTypeLists[0]['ink_type_id'];
        let selectedInkTypeName = this.inkTypeLists[0]['name'];
        if (this.projects.projects_data[this.activeProjectIndex]['ink_Details'] && this.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_type_id && this.projects.projects_data[this.activeProjectIndex]['ink_Details'].name) {
          selectedInkTypeId = this.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_type_id;
          selectedInkTypeName = this.projects.projects_data[this.activeProjectIndex]['ink_Details'].name;
        }
        if (selectedInkTypeId && selectedInkTypeId) {
          this.projects.projects_data[this.activeProjectIndex]['ink_Details'] = {
            'ink_type_id': selectedInkTypeId,
            'ink_name': selectedInkTypeName
          };
        }
      }
    }
    else {
      this._flashMessagesService.show("Ink type not found,Please add at least one ink type", {
        cssClass: "alert-danger",
        timeout: 5000
      });

    }
  }

  showConfirmMessage() {
    if (this.grandTotalPrice > 0 && this.prevPrice != this.grandTotalPrice) {
      localStorage.setItem("isorder", 'yes');
    }
  }

  selectPrintOption(obj) {
    let val = obj.split('^');
    let index, loc, buttonId, buttonName;
    index = val[0];
    loc = val[1];
    buttonId = val[2];
    buttonName = val[3];

    let defaultPrintPosition = JSON.parse(JSON.stringify(this.artworkPrintOpt[loc].locationSetting[index]['printPositions'][0]));
    let defaultMatrix = defaultPrintPosition.matrixData.find(x => x.is_default == 1);
    if (this.activeLocationArr.length > 1) {
      let secondaryMatrix = defaultPrintPosition.matrixData.find(x => x.is_secondary == 1);
      defaultMatrix = secondaryMatrix ? secondaryMatrix : defaultMatrix;
    }
    defaultMatrix = defaultMatrix ? defaultMatrix : defaultPrintPosition.matrixData[0];
    let matrixType = JSON.parse(JSON.stringify(this.artworkPrintOpt[loc].locationSetting[index].matrixType));
    let custom_stitches_per_inch = 0;
    this.inkColors = defaultMatrix.inks;
    this.stitches_per_inch = 0;
    if (this.activeLocationArr.length > 0) {
      this.activeLocationArr.forEach((cval, ckey) => {
        if (loc == cval.emblocation_id) {
          cval.emblocation_button_title = buttonName;
        }
      });
    }
    this.otherPrintSettings[loc] = {
      printPosition: defaultPrintPosition,
      nameTotalCount: '',
      numberTotalCount: '',
      printDistance: '',
      printWidth: matrixType == 'per_item' ? defaultMatrix.width : 0,
      printHeight: matrixType == 'per_item' ? defaultMatrix.height : 0,
      custom_stitches_per_inch: custom_stitches_per_inch,
      printDesciption: '',
      priceMatrix: defaultMatrix,
      selectedOptionId: buttonId,
      placementIndex: 0,
      selectedOptionIndex: index,
      includePreTreat: false,
      printType: matrixType,
    };

    delete this.selectedInkColorObj[loc];
    delete this.selectedInkColor[loc];
    delete this.inkChangeObj[loc];
    delete this.inkChangeData[loc];
    delete this.artworkHexColors[loc];
    delete this.selectedAdons[loc];
    this.processPrintData();
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    this.getPrice(this.tempProjectData);
  }

  changeMatrix(loc, matrixId) {
    let selectedPlacement = this.otherPrintSettings[loc].placementIndex;
    //selectedInkColorObj
    if(this.projects.projects_data[this.activeProjectIndex] && this.artworkPrintOpt[loc].locationSetting[this.otherPrintSettings[loc].selectedOptionIndex]['printPositions'][selectedPlacement].matrixData.find(x => x.matrix_id == matrixId).min_order_qty){
      const minMatrixQty = this.artworkPrintOpt[loc].locationSetting[this.otherPrintSettings[loc].selectedOptionIndex]['printPositions'][selectedPlacement].matrixData.find(x => x.matrix_id == matrixId).min_order_qty;
      const totalProjectQuantity = this.projects.projects_data[this.activeProjectIndex].totalProjectQuantity;
      if(totalProjectQuantity < minMatrixQty){
        if (!this.projects.store_id) {
          const errorMsg = "The total quantity of products for the selected embellishment type must be more than " + minMatrixQty;
          this._flashMessagesService.show(errorMsg, {
            cssClass: "alert-danger",
            timeout: 5000
          });
        }
      }
    }
    this.inkColors = this.artworkPrintOpt[loc].locationSetting[this.otherPrintSettings[loc].selectedOptionIndex]['printPositions'][selectedPlacement].matrixData.find(x => x.matrix_id == matrixId).inks;
    let matrixType = this.artworkPrintOpt[loc].locationSetting[this.otherPrintSettings[loc].selectedOptionIndex].matrixType;
    if (matrixType == 'per_color' || matrixType == 'per_item') {
      if (matrixType == 'per_item') {
        const selectedMatrixData = this.artworkPrintOpt[loc].locationSetting[this.otherPrintSettings[loc].selectedOptionIndex]['printPositions'][selectedPlacement].matrixData.find(x => x.matrix_id == matrixId);
        if (selectedMatrixData) {
          this.otherPrintSettings[loc].priceMatrix = selectedMatrixData;
          this.otherPrintSettings[loc].printHeight = selectedMatrixData.height;
          this.otherPrintSettings[loc].printWidth = selectedMatrixData.width;
        }
      }
      
      if ((this.selectedInkColorObj[loc] && this.selectedInkColorObj[loc].length > 0) || (this.selectedAdons[loc] && this.selectedAdons[loc].length > 0)) {
        this.selectedInkColorObj[loc].splice(0, this.selectedInkColorObj[loc].length);
        this.selectedInkColor[loc].splice(0, this.selectedInkColor[loc].length);
        this.processPrintData();
        this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
        this.getPrice(this.tempProjectData);
      }
    }
    else {
      this.processPrintData();
      this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
      this.getPrice(this.tempProjectData);
    }
  }

  modelChanged(value) {
    this.stitches_per_inch = (value != null) ? value : 0;
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    this.getPrice(this.tempProjectData);
  }

  getProductMatrix = function (catalogue) {
    this.loading = true;
    if (catalogue == 'all') {
      this.productOptions = {
        id: localStorage.getItem("userID")
      };
    } else {
      this.productOptions = {
        id: localStorage.getItem("userID"),
        provider: catalogue
      };
    }
    this.CommonService.apiService(
      "POST",
      "order/get_matrix",
      this.productOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.CommonProjectDataService.storeProductMatrix(response.data);
          this.productMatrix = this.CommonProjectDataService.getProductMatrix();
        }
      },
      err => {
        console.log(err);
      }
    );
    this.loading = false;
  };

  resetArtwork(active_artwork_loc, img_ext_path, org_file_ext_path, active_uui) {
    this.deleteFile(img_ext_path, org_file_ext_path, active_uui);
    this.artworkHexColors[active_artwork_loc] = {};
    this.projects.projects_data[this.activeProjectIndex]["artwork"] = Object.assign({}, this.artworkHexColors);
    this.CommonProjectDataService.store(this.projects);
  }

  deleteFile = function (file_name, artwork_img, artwork_id) {
    let fd = new FormData();
    fd.append("id", localStorage.getItem("userID"));
    fd.append("img_name", file_name);
    fd.append("artwork_img", ((artwork_img) ? artwork_img : ''));
    fd.append("actionType", "deleteFile");
    fd.append("artwork_id", artwork_id);

    this.CommonService.apiService(
      "POST",
      "artwork/delete",
      fd
    ).subscribe(
      (response: any) => {
        if (response.status === true) {

        }
      },
      err => {
        console.log('Error', err.error.message);
      }
    );
  }

  setProjectIndexForCheckboxTabs(index) {
    if (!this.projects.projectIndexForCheckboxTabs) {
      this.projects.projectIndexForCheckboxTabs = [index];
    }
    else {
      if (!this.projects.projectIndexForCheckboxTabs.includes(index)) {
        this.projects.projectIndexForCheckboxTabs.push(index);
      }
    }
    this.CommonProjectDataService.store(this.projects);
  }

  openDeleteDialog(active_artwork_loc, img_ext_path, org_file_ext_path, active_uui): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "",
        message: "Are you sure you want to delete this art file?",
        manageData: { active_artwork_loc: active_artwork_loc }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (active_artwork_loc) {
          this.resetArtwork(active_artwork_loc, img_ext_path, org_file_ext_path, active_uui);
        }
      }
    });
  }


  SetValue(param, emblocation_id) {
    let data = this.artworkPrintOpt[emblocation_id].locationSetting.filter(x => x.id === param);
    if (data) {
      let index, loc, buttonId, buttonName;
      index = this.artworkPrintOpt[emblocation_id].locationSetting.findIndex(x => x.id === param);
      loc = emblocation_id;
      buttonId = data[0].id;
      buttonName = data[0].buttonTitle;
      return (index + '^' + loc + '^' + buttonId + '^' + buttonName);
    }
  }

  getImpressionLocationCost(printPositionKey: any): number {
    const activeProject = this.projects.projects_data[this.activeProjectIndex];

    if (activeProject && activeProject.priceDistributionData) {
      const distributionData = activeProject.priceDistributionData.find(
        (d) => d.printPositionKey === printPositionKey
      );

      return distributionData ? distributionData.perProductTotalPrintingCost : 0;
    }

    return 0;
  }

  isDistanceOnPortal(locData, emblocationId){
    let isDistanceOn = false;
    const valueType = this.isPublicQuoteCreation ? 'isDistanceOnCustomerPortal' : 'isDistanceOnAdminPortal';
    if (locData && !locData.hasOwnProperty(`${valueType}`)) {
      isDistanceOn = true;
    } else {
      isDistanceOn = locData[`${valueType}`] ? true : isDistanceOn;
    }
    if(isDistanceOn && this.projects.projects_data[this.activeProjectIndex].printPositionSetting && this.projects.projects_data[this.activeProjectIndex].printPositionSetting[emblocationId]){
      this.projects.projects_data[this.activeProjectIndex].printPositionSetting[emblocationId].isDistanceOnPortal = isDistanceOn;
      this.CommonProjectDataService.store(this.projects);
    }
    return isDistanceOn;
  }

  isAccessInvoiceType() {
    const hasOrderType = this.CommonProjectDataService.getOrderType();
    const isInvoiceEditable = this.CommonProjectDataService.getIsInvoiceEditable();
    const isRedirectUrl = this.settingService.isAccessInvoiceType(hasOrderType, this.isPublicQuoteCreation, isInvoiceEditable);
    if (isRedirectUrl) {
      return this.router.navigate([isRedirectUrl]);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/print-specs/print-specs.component.ts